import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { MatIconRegistry } from '@angular/material/icon';


import { AppService } from './core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {

  constructor(
    private _appService: AppService,
    private _iconRegistry: MatIconRegistry,
  ) {
    this._appService.init();
    this._iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
  }

}
